// Returns true if timestamp is not today
export const isOld = (timestamp: number): boolean => {
  const previous = new Date(timestamp)
  const current = new Date()

  return (
    previous.getFullYear() !== current.getFullYear() ||
    previous.getMonth() !== current.getMonth() ||
    previous.getDate() !== current.getDate()
  )

  // use for testing only
  // return previous.getMinutes() !== current.getMinutes();
}
